import { useMemo } from 'react'

import { useInvoiceComplianceMode } from '@features/invoices/hooks/useInvoiceComplianceMode'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getMissingCompanyComplianceDetails } from '../../utils/missingComplianceDetails/getMissingCompanyComplianceDetails'
import { getMissingCustomerComplianceDetails } from '../../utils/missingComplianceDetails/getMissingCustomerComplianceDetails'
import { usePredefinedCompanyValues } from './usePredefinedCompanyValues'
import { usePredefinedCustomerValues } from './usePredefinedCustomerValues'

export const useMissingComplianceDetails = () => {
  const { organization } = useUserOrganization()
  const { predefinedCompanyValues } = usePredefinedCompanyValues()
  const { predefinedCustomerValues } = usePredefinedCustomerValues()
  const { invoiceComplianceMode } = useInvoiceComplianceMode()

  const isMissingCustomerEInvoicingAddress = !predefinedCustomerValues?.eInvoiceAddress?.address
  const isVatExempted = !!organization?.isVatExempted

  const {
    isMissingCompanyAddress,
    isMissingCompanyDetails,
    isMissingCompanyPaymentInfo,
    isMissingCompanyTaxInfo,
    isMissingLegalInfo,
    isMissingLegalStatus,
    isMissingSharedCapital,
  } = useMemo(
    () =>
      getMissingCompanyComplianceDetails({
        companyValues: predefinedCompanyValues,
        complianceMode: invoiceComplianceMode,
        isVatExempted,
      }),
    [invoiceComplianceMode, isVatExempted, predefinedCompanyValues],
  )

  const { isMissingCustomerAddress, isMissingCustomerDetails, isMissingCustomerTaxInfo } = useMemo(
    () =>
      getMissingCustomerComplianceDetails({
        complianceMode: invoiceComplianceMode,
        customerValues: predefinedCustomerValues,
      }),
    [invoiceComplianceMode, predefinedCustomerValues],
  )

  const isMissingComplianceDetails = isMissingCompanyDetails || isMissingCustomerDetails || isMissingLegalInfo

  return {
    isMissingCompanyAddress,
    isMissingCompanyDetails,
    isMissingCompanyPaymentInfo,
    isMissingCompanyTaxInfo,
    isMissingComplianceDetails,
    isMissingCustomerAddress,
    isMissingCustomerDetails,
    isMissingCustomerEInvoicingAddress,
    isMissingCustomerTaxInfo,
    isMissingLegalInfo,
    isMissingLegalStatus,
    isMissingSharedCapital,
  }
}
